<div class="message-image">
  <app-images-group-view
    [filesCount]="files.length"
    [files]="filesForGroup"
    [width]="maxWidth"
    [height]="maxHeight"
  ></app-images-group-view>

  <message-text *ngIf="message.content.text" [message]="message"></message-text>
</div>
